<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("adicionar-fase-fenologica") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button 
                    class="delete-btn" 
                    type="button" 
                    @click="fecharModal()"
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="faseFenologicaSelecionado.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <br/>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="fasefenologicas"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :header-checkable="false"
                :checked-rows.sync="faseFenologicaSelecionado"
                :custom-is-checked="(selecionados, linha) => selecionados.id === linha.id"
                :is-row-checkable="(row) => faseFenologicaSelecionado.length === 0 || faseFenologicaSelecionado.includes(row)"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import FaseFenologicaService from "@/services/agro/FaseFenologicaService";
import AgroFenologiaItemService from "@/services/agro/fenologia/AgroFenologiaItemService";

/* @70957 */
export default {
    props: {
        fenologia: {},
    },
    data() {
        return {
            service: new FaseFenologicaService(this.$http, this.$router),
            serviceFenologiaItem: new AgroFenologiaItemService(this.$http, this.$router),
            fasefenologicas: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'descricao', width: null, sortable: true }
            ],
            faseFenologicaSelecionado: [],
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],
            fenologiaItem: null,
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                1,
                this.fenologia.cultura.id,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.fasefenologicas = value;
                this.isEmpty = this.fasefenologicas.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados. ' + e);
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    id: m.agroFaseFenologica.id,
                    descricao: m.agroFaseFenologica.descricao,
                    uuidAgroFaseFenologicaOreg: this.fenologia.uuid
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.faseFenologicaSelecionado.length > 0) {
                this.isLoading = true;

                let faseFenologica = this.faseFenologicaSelecionado[0];

                this.fenologiaItem = {
                    uuidAgroFaseFenologicaOreg: faseFenologica.uuidAgroFaseFenologicaOreg,
                    idAgroFaseFenologica: faseFenologica.id,
                    situacao: 4
                };

                // pega alocalização através do navegador caso esteja liberado
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
                }
                
                this.serviceFenologiaItem.save(this.fenologiaItem)
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch(() => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            }
        },
        fecharModal() {
            this.$emit("fecharModal", true);
        },
        successPosition(position){
            this.fenologiaItem.latitude = (position.coords.latitude)?position.coords.latitude:0;
            this.fenologiaItem.longitude = (position.coords.longitude)?position.coords.longitude:0;
            this.fenologiaItem.lastfix = (position.timestamp)?position.timestamp:null;
            this.fenologiaItem.tipogps = (position.coords.latitude)?1:0;
        },
        errorPosition(e){
            console.error('Geolocation error!', e);
        },
    },
}
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
